import type { RouteRecordRaw } from 'vue-router';

/**
 * Журнал змін бачить лише суперадмін: право `ugi:core:audit-log:list` не дано
 * жодній ролі (рішення власника 2026-10-19).
 */
export const auditLogRoute: RouteRecordRaw = {
  path: '/audit',
  name: 'AuditLog',
  component: () => import('./pages/AuditLogPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:audit-log:list'),
  },
};
